import { IconGlobe } from "components/Icons/IconGlobe";
import { IconPeople } from "components/Icons/IconPeople";
import { IconTerminalWindow } from "components/Icons/IconTerminalWindow";
import { Tooltip } from "components/Tooltip/Tooltip";
import styles from "./TableFooter.module.css";

export const TableFooter = () => {
  return (
    <div className={styles.tableFooter}>
      <p>Every Dune plan comes with</p>

      <div className={styles.features}>
        <IconPeople />
        Unlimited free teammates
      </div>
      <div className={styles.features}>
        <Tooltip
          label={
            <>
              Run queries manually in the Dune app for free. <br />
              Medium size query engine with no guarantees.
            </>
          }
          position="above-center"
        >
          <div>
            <IconGlobe />
            Unlimited free executions
          </div>
        </Tooltip>
      </div>
      <div className={styles.features}>
        <IconTerminalWindow />
        API access
      </div>
    </div>
  );
};
